import { API_DOMAIN, AVATAR_DOMAIN } from '@constants';
import useEditingStore from '@hooks/useEditingStore';
import { $tourData } from '@stores/dataStores';
import { $GateEditingAuthor } from '@stores/editingStores';
import { $isTeamAccount, $member } from '@stores/memberStores';
import axios from '@utils/axios';
import { useStore, useStoreMap } from 'effector-react';
import { useQuery } from 'react-query';

const useNickname = () => {
  const { property } = useStore($member);
  const isTeamAccount = useStore($isTeamAccount);
  const { data } = useQuery(['teamInfo'], async () => {
    return axios.get<{ ownerName: string; ownerAvatar: string }>(
      `${API_DOMAIN}/team/info`
    );
  });
  const operatorName = useStoreMap({
    store: $tourData,
    keys: [],
    fn: (state) => state.operatorName,
  });

  const author = useEditingStore({
    $data: $tourData,
    dataFn: (state) => state.config?.author ?? {},
    $editing: $GateEditingAuthor.state,
  });

  let name = isTeamAccount ? data?.ownerName : property?.nickname;
  const avatar = isTeamAccount
    ? `${AVATAR_DOMAIN}${data?.ownerAvatar}`
    : `${AVATAR_DOMAIN}${property?.avatar}`;

  if (author.mode === 1) {
    name = operatorName;
  } else if (author.mode === 2) {
    name = author.customNickname;
  }

  return {
    name,
    avatar,
  };
};

export default useNickname;
